(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olaola-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(){
 document.querySelectorAll('.ix-rev__track').forEach(track=>{
  if(track.dataset.olaolaScroll)return;
  track.dataset.olaolaScroll='true';
  const cards=Array.from(track.querySelectorAll('.ix-rev__card'));
  const dots=Array.from(track.parentElement.querySelectorAll('.ix-rev__dot'));
  if(!cards.length)return;
  const target=index=>{
   const card=cards[index];
   const centered=card.getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft-(track.clientWidth-card.offsetWidth)/2;
   return Math.max(0,Math.min(centered,track.scrollWidth-track.clientWidth));
  };
  const update=()=>{
   let active=0,distance=Infinity;
   cards.forEach((card,index)=>{const delta=Math.abs(track.scrollLeft-target(index));if(delta<distance){distance=delta;active=index;}});
   dots.forEach((dot,index)=>{dot.classList.toggle('active',index===active);dot.setAttribute('aria-current',index===active?'true':'false');});
  };
  dots.forEach((dot,index)=>dot.addEventListener('click',()=>{
   track.scrollTo({left:target(index),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }));
  track.addEventListener('scroll',update,{passive:true});
  new ResizeObserver(update).observe(track);
  update();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);
document.addEventListener('shopify:block:select',event=>{const block=event.target;if(block.matches('details'))block.open=true;if(block.matches('.ix-rev__card,.ix-reel'))block.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-product-details"] && !Shopify.designMode) return;
  try {
    

(function() {
let dispose = () => {};
function initCalculator() {
  dispose();
  const triggerBtn = document.getElementById('open-size-calculator');
  const overlay = document.getElementById('size-calc-overlay');
  const closeBtn = document.getElementById('close-popup');
  const calculateBtn = document.getElementById('calculate-size');
  const waistInput = document.getElementById('waist-input');
  const hipsInput = document.getElementById('hips-input');
  const resultDiv = document.getElementById('size-result');
  const errorDiv = document.getElementById('size-error');
  const recommendedSize = document.getElementById('recommended-size');
  const resultExplanation = document.getElementById('result-explanation');
  if (!triggerBtn || !overlay || !overlay.hasAttribute('data-olaola-section')) return;
  const controller = new AbortController();
  const signal = controller.signal;
  dispose = () => { controller.abort(); if (overlay.classList.contains('active')) closePopup(); if (!triggerBtn.isConnected) overlay.remove(); };

  const sizeChart = [
    { size: 'XS/S', euSize: '36-38', waistMin: 59,  waistMax: 68,  hipsMin: 86,  hipsMax: 92  },
    { size: 'M',    euSize: '40-42', waistMin: 69,  waistMax: 75,  hipsMin: 93,  hipsMax: 100 },
    { size: 'L',    euSize: '44-46', waistMin: 76,  waistMax: 82,  hipsMin: 101, hipsMax: 108 },
    { size: 'XL',   euSize: '48',    waistMin: 83,  waistMax: 93,  hipsMin: 109, hipsMax: 116 },
    { size: '2XL',  euSize: '50-52', waistMin: 94,  waistMax: 104, hipsMin: 117, hipsMax: 124 },
    { size: '3XL',  euSize: '54-56', waistMin: 105, waistMax: 116, hipsMin: 125, hipsMax: 132 }
  ];
  
  let returnFocus = null;
  let previousOverflow = '';

  function openPopup(event) {
    event.preventDefault();
    if (overlay.classList.contains('active')) return;
    returnFocus = event.target.closest('button, a') || triggerBtn;
    previousOverflow = document.body.style.overflow;
    document.body.appendChild(overlay);
    overlay.classList.add('active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    overlay.querySelector('.size-calc-popup').scrollTop = 0;
    waistInput.focus({ preventScroll: true });
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('#open-size-calculator, a[href="#open-size-calculator"]')) {
      event.stopPropagation();
      openPopup(event);
    }
  }, {capture:true, signal});

  function closePopup() {
    overlay.classList.remove('active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = previousOverflow;
    waistInput.value = '';
    hipsInput.value = '';
    resultDiv.style.display = 'none';
    errorDiv.style.display = 'none';
    if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
  }

  closeBtn.addEventListener('click', closePopup, {signal});
  overlay.addEventListener('click', function(event) {
    if (event.target === overlay) closePopup();
  }, {signal});

  document.addEventListener('keydown', function(event) {
    if (!overlay.classList.contains('active')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup();
    } else if (event.key === 'Tab') {
      const controls = Array.from(overlay.querySelectorAll('button, input')).filter(el => !el.disabled);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }, {signal});

  calculateBtn.addEventListener('click', function() {
    const waist = parseFloat(waistInput.value);
    const hips = parseFloat(hipsInput.value);
    
    if (!waist || !hips || waist < 50 || waist > 140 || hips < 80 || hips > 160) {
      errorDiv.style.display = 'block';
      resultDiv.style.display = 'none';
      return;
    }
    
    errorDiv.style.display = 'none';
    
    let recommendedSizeObj = null;
    let explanation = '';

    for (let i = 0; i < sizeChart.length; i++) {
      const size = sizeChart[i];
      if (hips >= size.hipsMin && hips <= size.hipsMax) {
        recommendedSizeObj = size;
        if (waist >= size.waistMin && waist <= size.waistMax) {
          explanation = `Twoje pomiary idealnie pasują do rozmiaru ${size.size} (EU ${size.euSize}). Technologia 3D będzie optymalnie umiejscowiona na biodrach i pośladkach.`;
        } else {
          explanation = `Rekomendujemy rozmiar ${size.size} (EU ${size.euSize}) na podstawie obwodu bioder (${hips} cm). Wysoki elastyczny pas dopasuje się do talii.`;
        }
        break;
      }
    }

    if (!recommendedSizeObj) {
      for (let i = 0; i < sizeChart.length - 1; i++) {
        if (hips > sizeChart[i].hipsMax && hips < sizeChart[i + 1].hipsMin) {
          recommendedSizeObj = sizeChart[i + 1];
          explanation = `Twoje biodra (${hips} cm) są między dwoma rozmiarami. Rekomendujemy większy rozmiar ${recommendedSizeObj.size} (EU ${recommendedSizeObj.euSize}) dla optymalnego komfortu.`;
          break;
        }
      }
    }

    if (!recommendedSizeObj) {
      if (hips < sizeChart[0].hipsMin) {
        recommendedSizeObj = sizeChart[0];
        explanation = `Na podstawie Twoich pomiarów rekomendujemy rozmiar ${recommendedSizeObj.size} (EU ${recommendedSizeObj.euSize}). W razie wątpliwości skontaktuj się z nami!`;
      } else if (hips > sizeChart[sizeChart.length - 1].hipsMax) {
        recommendedSizeObj = sizeChart[sizeChart.length - 1];
        explanation = `Na podstawie Twoich pomiarów rekomendujemy rozmiar ${recommendedSizeObj.size} (EU ${recommendedSizeObj.euSize}). W razie wątpliwości skontaktuj się z nami!`;
      }
    }
    
    if (recommendedSizeObj) {
      recommendedSize.textContent = recommendedSizeObj.size;
      resultExplanation.textContent = explanation;
      resultDiv.style.display = 'block';
      
      const sizeSelector = document.querySelector('select[name="Size"], select[name="Rozmiar"]');
      if (sizeSelector) {
        const options = sizeSelector.options;
        for (let i = 0; i < options.length; i++) {
          if (options[i].value.includes(recommendedSizeObj.size) || options[i].text.includes(recommendedSizeObj.size)) {
            sizeSelector.selectedIndex = i;
            sizeSelector.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }
    }
  }, {signal});
  
  [waistInput, hipsInput].forEach(input => {
    input.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        calculateBtn.click();
      }
    }, {signal});
  });
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCalculator, {once:true}); else initCalculator();
document.addEventListener('shopify:section:load', initCalculator);
document.addEventListener('shopify:section:unload', event => { if(event.target.querySelector('#open-size-calculator')) dispose(); });
})();


  } catch(e) { console.error(e); }
})();
})();
